import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import LayoutFixHome from "../components/LayoutFixHome";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { RoutesConfig } from "../router/types";
import UserOptions from "../components/UserOptions";

export const CadastrarUsuario: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleBack = () => {
    navigate(RoutesConfig.USUARIOS.path);
  };

  return (
    <>
      <LayoutFixHome>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "29px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              marginTop: {
                sm: "75px",
                xs: "75px",
                md: 0,
              },
            }}
          >
            <Box
              onClick={handleBack}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <ExpandCircleDownOutlinedIcon
                style={{ transform: "rotate(-270deg)" }}
                sx={{ color: "#0A0C33", height: "30px", width: "30px" }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", color: "#0A0C33" }}
            >
              Cadastro de Usuário
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            border: "1px solid #0A0C33",
            height: {
              xs: "100vh",
              sm: "100vh",
              md: "81vh",
            },
            borderRadius: "15px",
            p: 3,
          }}
        >
          <UserOptions />
        </Box>
      </LayoutFixHome>
    </>
  );
};
